import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../../css/components/Pricing.css';
import { useToast } from './ToastProvider';
import PaymentButton from './paymentButton';


//import PaymentButton from './PaymentButton';
const plans = [
  {
    name: 'Basic',
    badge: null,
    price: "0",
    description: 'Get a taste of smart automation — perfect for testing the waters. But you might quickly outgrow it.',
    features: [
      'Use Smart Text Tagging (<a>...</a>) with AI suggestions',
      '20 AI-powered prompts per month',
      "700-character limit per prompt."
      
    ],
    button: 'Get Started Free',
    buttonLink: '/extension_login',
    highlight: false,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
        <circle cx="12" cy="7" r="4"></circle>
      </svg>
    )
  },
  {
    name: 'Professional',
    badge: 'Most Popular',
    price: 49,
    description: 'Step into pro productivity. Designed for creators and teams who need smarter, faster, customizable workflows.',
    features: [
      'Everything in Basic',
      '150 AI-powered prompts per month',
      'Customizable tag support (<a>, <b>, or your own)',
      "2500-character limit per prompt."
    ],
    button: 'Upgrade Now',
    buttonLink: '/extension_login',
    highlight: true,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
      </svg>
    )
  },
  {
    name: 'Professional+',
    badge: 'Unlimited',
    price: 199,
    description: 'Unlock the full power of automation. For power users who cant afford limits — go faster, smarter, and bigger.',
    features: [
      'Everything in Professional',
      'Unlimited AI-powered prompts',
      "4000-character limit per prompt."
      
    ],
    button: 'Upgrade Now',
    buttonLink: '/extension_login',
    highlight: false,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2v20"></path>
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
      </svg>
    )
  }
];


const Pricing = () => {
  const [annual, setAnnual] = useState(false);
  const toast = useToast();
  
  return (
    <section className="pricing-section" id="pricing">
    
      
      <div className="container">
        <div className="pricing-header">
         
          
          <h2 className="section-title animate-fade-in">
            Unlock Your <span className="text-gradient">Productivity Potential</span>
          </h2>
          
          <p className="section-subtitle animate-fade-in">
            From everyday users to productivity pros, our flexible plans are built to scale your creativity, 
            save time, and help you do more—with less effort.
          </p>

          <h6 className="section-title animate-fade-in">
          Gave a prompt in a single line
          </h6>
          
          <div className="toggle-container animate-fade-in">
            <div className="toggle-row">
              <span className={!annual ? 'active' : ''}>Monthly</span>
              <label className="switch">
                <input 
                  type="checkbox" 
                  checked={annual} 
                  onChange={() => setAnnual(!annual)} 
                />
                <span className="slider"></span>
              </label>
              <span className={annual ? 'active' : ''}>
                Annually <span className="discount">15% off</span>
              </span>
            </div>
          </div>
        </div>
        
        <div className="pricing-cards">
          {plans.map((plan, idx) => (
            <div 
              key={plan.name} 
              className={`pricing-card animate-slide-up${plan.highlight ? ' featured' : ''}`}
              style={{ animationDelay: `${idx * 0.1}s` }}
            >
              {plan.badge && (
                <div className="plan-badge">{plan.badge}</div>
              )}
              
              <div className="plan-icon">{plan.icon}</div>
              <div className="plan-title">{plan.name}</div>
              <div className="plan-desc">{plan.description}</div>
              
              <div className="plan-price-row">
                <span className="plan-currency">₹</span>
                <span className="plan-price">
                  {annual ? Math.round(plan.price * 12 * 0.85) : plan.price}
                </span>
                <span className="plan-duration">/ {annual ? "year" : "month"}</span>
              </div>
              
              {plan.name === 'Basic' ? (
                <button onClick={() => window.open("https://chromewebstore.google.com/detail/coagkcndokekpcpmelffnlkmodfnhmjo?utm_source=item-share-cb", "_blank")}
                 to={plan.buttonLink} className={`plan-btn${plan.highlight ? ' primary' : ''}`}>
                  <>
                    {plan.button}
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="btn-icon">
                      <line x1="5" y1="12" x2="19" y2="12"></line>
                      <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                  </>
                </button>
              ) : (
               
                <PaymentButton
                amount= {annual ? Math.round(plan.price * 12 * 0.85) : plan.price}
               className={`plan-btn${plan.highlight ? ' primary' : ''}`}
               planName={plan.name}
               planValidity={annual? "1 year" : "1 month"}
               isannual={annual}
                >
                
                  {plan.name === 'Professional' ? (
                    <>
                      <span className="btn-text">{plan.button}</span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="btn-icon">
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                      </svg>
                      <span className="btn-shine"></span>
                    </>
                  ) : (
                    <>
                      {plan.button}
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="btn-icon">
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                      </svg>
                    </>
                  )}
                </PaymentButton>
              )}
              
              <div className="plan-features-title">What's included:</div>
              <ul className="plan-features">
                {plan.features.map((feature, i) => (
                  <li key={i} className="feature-item">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feature-check">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        
       
      </div>
    </section>
  );
};

export default Pricing;